import { c as _c } from "react/compiler-runtime";
import { FloatingBox, FloatingBoxProps } from '@/components/boxes';
import React from 'react';
import Image from 'next/image';
import { BoxWithImage, BoxWithVideo } from '@/sections/Floating';
import { VideoBox } from '@/components/VideoBox';
export function FloatingBoxes(t0) {
  const $ = _c(4);
  const {
    boxes
  } = t0;
  let t1;
  if ($[0] !== boxes) {
    t1 = boxes.map(_temp);
    $[0] = boxes;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex flex-col gap-8 md:gap-8">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(article, key) {
  return <FloatingBox key={key} title={article.title} anchorKey={article.anchorKey} image={article.image ? <Image alt={article.image.alt} src={article.image.src} width={468} height={468} /> : <VideoBox videoUrl={article.videoUrl} />} content={article.content} imagePosition={article.imagePosition} variant={article.variant} />;
}